import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setRoleLoading, setRoleError } from "../../repository/slice";

function* updateRoleWorker({ payload }: any): SagaIterator {
    try {
        yield put(setRoleLoading(true));
        const { data, message, isError }: IResponse<number[]> = yield call(requester.put, "/api/role/update", payload);
        if (isError) {
            yield put(setRoleError(message));
        }
    } catch (error) {
        console.error("creteRoleWorker: ", error);
    } finally {
        yield put(setRoleLoading(false));
    };
};

export function* updateRoleWatcher() {
    yield takeLatest("@saga/UPDATE_ROLE", updateRoleWorker);
};